import type { EcommercePayload, FormSubmitPayload, PayloadItem } from "./type"

export const pushToDataLayer = (payload: Record<string, any>) => {
  if (!process.client) return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
}


// ---------- Internal helper ----------
const pushEcommerceEvent = (
  event: string,
  ecommerce
) => {
  // GA4 best practice: reset
  pushToDataLayer({ ecommerce: null })

  pushToDataLayer({
    event,
    ecommerce
  })
}

// ---------- Public API ----------
export const gtmAddToCart = (payload: EcommercePayload) => {
  pushEcommerceEvent('add_to_cart', payload)
}

export const gtmBeginCheckout = (payload: EcommercePayload) => {
  pushEcommerceEvent('begin_checkout', payload)
}

export const gtmPurchase = (
  payload: EcommercePayload & {
    transaction_id: string|number
  }
) => {
  pushEcommerceEvent('purchase', payload)
}

export const gtmViewItem = (payload: { items: PayloadItem[] }) => {
  pushEcommerceEvent('view_item', payload)
}

export const gtmCheckAvailability = (payload: { items: PayloadItem[] }) => {
  pushEcommerceEvent('check_availability', payload)
}

export const gtmSelectOptions = (payload: { items: PayloadItem[] } ) => { // when??
   pushEcommerceEvent('select_item_options', payload)
}

export const gtmCtaClick = (payload: { name: string, location: string }) => {
  window.dataLayer.push({
    event: 'cta_click',
    cta_name: payload.name,
    cta_location: payload.location,
  });
}

export const gtmWhatsappClick = () => {
  window.dataLayer.push({
    event: 'whatsapp_click'
  });
}

export const gtmFormSubmit = (payload: FormSubmitPayload) => {  
  pushToDataLayer({
    event: 'form_submit',
    form_name: payload.form_name,
    form_location: window.location.pathname,
    experience_name: payload.experience_name,
    option_name: payload.option_name,
    page_url: window.location.href,
  })
}